import { FC, useContext } from 'react';
import { useController } from 'react-hook-form';
import Icon from '@common/assets';
import { CalendarContext } from '../../contextWrap';
import DateFormat from '@utils/date/format';
import DateUtil from '@utils/date/util';
import classnames from 'classnames/bind';
import styles from './calendarHeader.module.scss';
const cx = classnames.bind(styles);

const TODAY = DateUtil.getNow();

interface ArrowBtnAreaProps {
  setIsFocusDate: (focus: boolean) => void;
}

const ArrowBtnArea: FC<ArrowBtnAreaProps> = ({ setIsFocusDate }) => {
  const { calendarInfo, miniCalendarInfo, filter } = useContext(CalendarContext);
  const { field: targetMonthField } = useController({ name: 'targetMonth' });
  const titleText = `${calendarInfo.calendarDate.getFullYear()}년 ${calendarInfo.calendarDate.getMonth() + 1}월`;

  const onClickPrevMonthBtn = () => {
    setIsFocusDate(false);
    const prevMonth = new Date(calendarInfo.calendarDate);
    prevMonth.setDate(1); //5월 31일에서 월을 1감소 시켰을 경우 4월 31일이 없어 5월로 유지되는 문제 해결
    prevMonth.setMonth(calendarInfo.calendarDate.getMonth() - 1);
    const newTargetMonth = DateFormat.format(prevMonth, 'yyyy-MM');
    calendarInfo.setCalendarDate(prevMonth);
    targetMonthField.onChange(newTargetMonth);
    filter.setLatestFilter({ ...filter.latestFilter, targetMonth: newTargetMonth });
    window.scrollTo(0, 0);
  };

  const onClickNextMonthBtn = () => {
    setIsFocusDate(false);
    const nextMonth = new Date(calendarInfo.calendarDate);
    nextMonth.setDate(1); //5월 31일에서 월을 1증가 시켰을 경우 6월 31일이 없어 7월로 넘어가는 문제 해결
    nextMonth.setMonth(calendarInfo.calendarDate.getMonth() + 1);
    const newTargetMonth = DateFormat.format(nextMonth, 'yyyy-MM');
    calendarInfo.setCalendarDate(nextMonth);
    targetMonthField.onChange(newTargetMonth);
    filter.setLatestFilter({ ...filter.latestFilter, targetMonth: newTargetMonth });
    window.scrollTo(0, 0);
  };

  const onClickTodayBtn = () => {
    setIsFocusDate(true);
    miniCalendarInfo.setSelectedDate(TODAY);
    calendarInfo.setCalendarDate(TODAY);
    const newTargetMonth = DateFormat.format(TODAY, 'yyyy-MM');
    targetMonthField.onChange(newTargetMonth);
    filter.setLatestFilter({ ...filter.latestFilter, targetMonth: newTargetMonth });
  };

  return (
    <div className={cx('dateArea')}>
      {/* 날짜 및 월 이동 영역 */}
      <div className={cx('dateWrap')}>
        {/* 이전 버튼 */}
        <a className={cx('btnPrev')} role="button" onClick={onClickPrevMonthBtn}>
          <Icon name="arrowLeftLight" width={32} height={32} />
        </a>

        {/* 날짜 */}
        <em className={cx('date')}>{titleText}</em>

        {/* 다음 버튼 */}
        <a className={cx('btnNext')} role="button" onClick={onClickNextMonthBtn}>
          <Icon name="arrowRightLight" width={32} height={32} />
        </a>
      </div>

      {/* 오늘 버튼 */}
      <a className={cx('btnToday')} role="button" onClick={onClickTodayBtn}>
        오늘
      </a>
    </div>
  );
};

export default ArrowBtnArea;
